import React, { useEffect, useLayoutEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { ApiHttpService } from '../utils/http/api';
import { getCurrentLanguageId } from '../utils';
import CourseHistory from './sections/contest/CourseHistory';
import People from './People';
import PageContent from './shared/PageContent';

const CACHE_PREFIX = 'slugPage:v2';

function cacheKey(slug, languageId) {
  return `${CACHE_PREFIX}:${languageId}:${slug}`;
}

function readSlugPageCache(slug, languageId) {
  try {
    const raw = localStorage.getItem(cacheKey(slug, languageId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.type !== 'string') return null;
    return { type: parsed.type, data: parsed.data };
  } catch {
    return null;
  }
}

function writeSlugPageCache(slug, languageId, type, data) {
  try {
    localStorage.setItem(
      cacheKey(slug, languageId),
      JSON.stringify({ type, data, savedAt: Date.now() })
    );
  } catch {
    // storage full or unavailable
  }
}

function Slug() {
    const { slug } = useParams();
    const languageId = getCurrentLanguageId();

    const [applied, setApplied] = useState(() => {
      const c = readSlugPageCache(slug, languageId);
      return {
        slug,
        type: c?.type ?? null,
        data: c?.data ?? null,
        loading: !c,
      };
    });

    const inSync = applied.slug === slug;

    useLayoutEffect(() => {
      const c = readSlugPageCache(slug, languageId);
      setApplied({
        slug,
        type: c?.type ?? null,
        data: c?.data ?? null,
        loading: !c,
      });
    }, [slug, languageId]);

    useEffect(() => {
      let cancelled = false;

      ApiHttpService.findBySlug(slug)
        .then((res) => {
          if (cancelled) return;
          if (res.length > 0) {
            const item = res[0];
            writeSlugPageCache(slug, languageId, item.type, item.object);
            setApplied((prev) => {
              if (prev.slug !== slug) return prev;
              return {
                slug,
                type: item.type,
                data: item.object,
                loading: false,
              };
            });
          } else {
            setApplied((prev) => {
              if (prev.slug !== slug) return prev;
              return { slug, type: null, data: null, loading: false };
            });
          }
        })
        .catch(() => {
          if (cancelled) return;
          setApplied((prev) => {
            if (prev.slug !== slug) return prev;
            return { ...prev, loading: false };
          });
        });

      return () => {
        cancelled = true;
      };
    }, [slug, languageId]);

    const showLoader = !inSync || (applied.loading && applied.type == null && applied.data == null);

    const { type, data } = applied;

  return (
    <div className="main-parent">
        {showLoader &&
            <>
                <div className="bounce-loader">
                    <div className="bounce1"></div>
                    <div className="bounce2"></div>
                    <div className="bounce3"></div>
                </div>
            </>
        }
        {inSync && type==="page" && <PageContent key={slug} pageItem={data}   />}
        {inSync && type==="course_history" && <CourseHistory key={slug} courseHistoryItem={data}   />}
        {inSync && type==="people" && <People key={slug} profile={data}   />}
    </div>
  )
}

export default Slug
